import React from 'react';
import { storiesOf } from '@kadira/storybook';

import 'modules/gallery/styles/gallery.css';
import Gallery from 'modules/gallery/components/Gallery';

storiesOf('Gallery', module)
  .add('Gallery without photos', () => (
    <Gallery />
  ))
  .add('Gallery with single photo', () => (
    <Gallery
      images="http://science-all.com/images/monkey/monkey-07.jpg"
    />
  ))
  .add('Gallery with two photos', () => (
    <Gallery
      images={[
        'http://science-all.com/images/monkey/monkey-07.jpg',
        'http://science-all.com/images/monkey/monkey-08.jpg',
      ]}
    />
  ))
  .add('Gallery with three photos', () => (
    <Gallery
      images={[
        'http://science-all.com/images/monkey/monkey-06.jpg',
        'http://science-all.com/images/monkey/monkey-07.jpg',
        'http://science-all.com/images/monkey/monkey-08.jpg',
      ]}
    />
  ))
  .add('Gallery with many photos', () => (
    <Gallery
      images={[
        'http://science-all.com/images/monkey/monkey-01.jpg',
        'http://science-all.com/images/monkey/monkey-02.jpg',
        'http://science-all.com/images/monkey/monkey-03.jpg',
        'http://science-all.com/images/monkey/monkey-04.jpg',
        'http://science-all.com/images/monkey/monkey-05.jpg',
        'http://science-all.com/images/monkey/monkey-06.jpg',
        'http://science-all.com/images/monkey/monkey-07.jpg',
        'http://science-all.com/images/monkey/monkey-08.jpg',
        'http://science-all.com/images/monkey/monkey-01.jpg',
        'http://science-all.com/images/monkey/monkey-02.jpg',
        'http://science-all.com/images/monkey/monkey-03.jpg',
        'http://science-all.com/images/monkey/monkey-04.jpg',
        'http://science-all.com/images/monkey/monkey-05.jpg',
        'http://science-all.com/images/monkey/monkey-06.jpg',
        'http://science-all.com/images/monkey/monkey-07.jpg',
        'http://science-all.com/images/monkey/monkey-08.jpg',
        'http://science-all.com/images/monkey/monkey-01.jpg',
        'http://science-all.com/images/monkey/monkey-02.jpg',
        'http://science-all.com/images/monkey/monkey-03.jpg',
        'http://science-all.com/images/monkey/monkey-04.jpg',
        'http://science-all.com/images/monkey/monkey-05.jpg',
        'http://science-all.com/images/monkey/monkey-06.jpg',
        'http://science-all.com/images/monkey/monkey-07.jpg',
        'http://science-all.com/images/monkey/monkey-08.jpg',
      ]}
    />
  ));
